export class CustomLinkUtils {
    static extractRoomIdFromCustomLink(customLink, isInitialLoad) {
        if (customLink == undefined) return undefined;
        if (isInitialLoad == false) return undefined;
        const referralTypeAndRoom = customLink.split('+');
        if (referralTypeAndRoom.length < 2) return undefined;
        const roomAndRoomId = referralTypeAndRoom[1].split('=');
        if (roomAndRoomId.length < 2) return undefined;
        if (roomAndRoomId[0] != 'room') return undefined;
        return roomAndRoomId[1];
    }
    static extractReferralTypeFromCustomLink(customLink) {
        const referralTypeAndRoom = customLink.split('+');
        return referralTypeAndRoom[0];
    }
    static parseShareLink(shareLink) {
        return shareLink.split('-');
    }
    static extractReferrerFromShareLink(shareLink) {
        return {
            referrer: this.parseShareLink(shareLink)[0],
            referralType: Number(this.parseShareLink(shareLink)[1])
        };
    }
}
